import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';

export class ChangePINViewModel {
    Dismiss:         (pAction: () => void)              => void;
    ShowAlert:       (pTitle: string, pMessage: string) => void;

    mlText:          MLText;
    app:             mlBroker;
    ml:              mlBroker;
    Hotel:           dmHotel;
    LangID:          number;

    NewPIN:          string;
    ConfirmNewPIN:   string;

    Staff:           RQService.Tasks.GetStaffRow;

    constructor(
         pMLText:    MLText
        ,pHotel:     dmHotel
        ,pDismiss:   (pAction: () => void)              => void
        ,pShowAlert: (pTitle: string, pMessage: string) => void
    ) {
        this.mlText          = pMLText;
        this.Hotel           = pHotel;
        this.LangID          = this.mlText.GetLangID();
        this.app             = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml              = this.mlText.GetBroker(
            'CTMExtranetStaff'
        );

        this.Dismiss         = pDismiss;
        this.ShowAlert       = pShowAlert;

        this.NewPIN          = '';
        this.ConfirmNewPIN   = '';
    }

    public initialise(staff: RQService.Tasks.GetStaffRow): void {
        this.Staff = staff;
    }

    public Cancel(): void {
        this.Dismiss(() => { return; });
    }

    public ChangePIN(): void {
        if (this.NewPIN.trim().length < 4) {
            this.ShowAlert(
                 this.ml.Text("CantChangePIN"        ,"Can't Change PIN")
                ,this.ml.Text("PINMustBe"            ,"PIN must be at least 4 characters")
            );

            return;
        }

        if (this.NewPIN.trim() != this.ConfirmNewPIN.trim()) {
            this.ShowAlert(
                 this.ml.Text("CantChangePIN"        ,"Can't Change PIN")
                ,this.ml.Text("PINAndReConfirmedPIN" ,"PIN and re-confirmed PIN do not match")
            );

            return;
        }

        let changePINParams = RQParam.TasksEditStaffPINParams();

        changePINParams.HotelID = this.Hotel.HotelID;
        changePINParams.StaffID = this.Staff.StaffID;
        changePINParams.PIN     = this.NewPIN;
        changePINParams.UserID  = 1;
        changePINParams.LangID  = this.LangID;

        RQService.Tasks.EditStaffPIN(changePINParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            this.ShowAlert(
                 this.ml.Text("PINChangedOK" ,"PIN Changed OK")
                ,this.ml.Text("PINChangedOK" ,"PIN Changed OK")
            );

            this.Dismiss(() => { return; });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/xv-change-pin-popover.ts